import { ROOT_COMPNENT_ID, IComponentType, } from '.';
export const CONTENT_DOC_VERSION = 27;
export const initCnDoc = () => {
    return {
        version: CONTENT_DOC_VERSION,
        rootComponentId: ROOT_COMPNENT_ID,
        screenRelativeScaleType: 'constant',
        projectColors: [],
        componentsById: {
            [ROOT_COMPNENT_ID]: {
                type: IComponentType.Root,
                children: [],
            }
        },
        mediaFilesById: {}
    };
};
